let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jj5e4")).then(() => parcelRequire('j3Lmi'));